'use strict';

var CmdDevice = require('./util/CmdDevice');
var log = require('../../../log/Log').channel('LibertyAvV1');

function LibertyAvV1(ipAddress, username, password, onConnectStatus, onControlStatus, config) {
    this.rxSrc = 'HDMI_RX';  // default source selected on receiver
    this.txSrc = 'VGA_TX';  // default source selected on transmitter
    this.busy = false;
    this.firmwareVersion = 'unknown';
    this.videoMatrixRoutes = {};
    this.videoOutputChannel = '1'; // default for liberty AV

    CmdDevice.call(this, ipAddress, username, password, onConnectStatus,
        onControlStatus, config);
}

LibertyAvV1.prototype = Object.create(CmdDevice.prototype);

LibertyAvV1.prototype.constructor = LibertyAvV1;

LibertyAvV1.prototype.name = 'LibertyAvV1';
LibertyAvV1.prototype.key = '-LWTYMJajlJaG8C4ttHB';
LibertyAvV1.prototype.isAsync = false;
LibertyAvV1.prototype.rejectAsync = false;
LibertyAvV1.prototype.syncTimeoutMs = 2000;
LibertyAvV1.prototype.sendTerminator = '\r';
LibertyAvV1.prototype.receiveTerminators = ['\r', '\n'];

LibertyAvV1.prototype.ports = [{
    port: 4999,
    verifySend: 'GET AUTOSW_FN RX',
    verifyConnection: /AUTOSW_FN\s.+/i,
    verifyTimeoutMs: 3000,
    loginSkip: null,
    loginVerifyTimeoutMs: 0,
    passwordPrompt: null,
    passwordPromptTimeoutMs: 0,
    passwordDefault: null,
    passwordSend: null,
    loginVerify: null,
    loginReject: null,
},{
    port: 23,
    verifySend: 'GET AUTOSW_FN RX',
    verifyConnection: /AUTOSW_FN\s.+/i,
    verifyTimeoutMs: 3000,
    loginSkip: null,
    loginVerifyTimeoutMs: 0,
    passwordPrompt: null,
    passwordPromptTimeoutMs: 0,
    passwordDefault: null,
    passwordSend: null,
    loginVerify: null,
    loginReject: null,
}];

LibertyAvV1.prototype.simulationParams = {
    caps: {
        hasVideoInputs: true,
        hasVideoOutputs: true,
        hasVideoSwitcher: true,
        hasFirmwareVersion: true,
    },
    firmwareVersion: '1.4',
};

LibertyAvV1.prototype.commands = {};

LibertyAvV1.prototype.commands.$getRouteInit = {};
LibertyAvV1.prototype.commands.$getRouteInit.isAsync = true;
LibertyAvV1.prototype.commands.$getRouteInit.activeStates = [ 'initializing' ];
LibertyAvV1.prototype.commands.$getRouteInit.activeInitializeStates = [ 'gettingRoutes' ];
LibertyAvV1.prototype.commands.$getRouteInit.get = function() {
    this.sendCommand('$getRouteInit', 'GET MP all all' );
};
LibertyAvV1.prototype.commands.$getRouteInit.match = /MP\sGET\s(.+)\sALL\s(RX|TX)/i;
LibertyAvV1.prototype.commands.$getRouteInit.process = function(match) {
    this.processSelectedInput(match);
    this.doNextInitializeStep();
};

LibertyAvV1.prototype.commands.$version = {};
LibertyAvV1.prototype.commands.$version.activeStates = [ 'initializing' ];
LibertyAvV1.prototype.commands.$version.activeInitializeStates = [ 'gettingVersion' ];
LibertyAvV1.prototype.commands.$version.get = function() {
    if (this.hasSync('$version')) return;
    this.sendCommand('$version', 'GET VER all rx');
};
LibertyAvV1.prototype.commands.$version.match = /VER\s+GET\s+MCU\s+(.+)\s+rx/i;
LibertyAvV1.prototype.commands.$version.process = function(match) {
    this.firmwareVersion = match[1];
    this.doNextInitializeStep();
};

LibertyAvV1.prototype.commands.busy = {};
LibertyAvV1.prototype.commands.busy.get = function() {
    this.broadcastStatus('busy', this.busy);
};

LibertyAvV1.prototype.commands.firmwareVersion = {};
LibertyAvV1.prototype.commands.firmwareVersion.get = function() {
    this.broadcastStatus('firmwareVersion', this.firmwareVersion);
};

LibertyAvV1.prototype.commands.ping = {};
LibertyAvV1.prototype.commands.ping.isAsync = true;
LibertyAvV1.prototype.commands.ping.activeStates = [ 'controlling', 'controlFailed' ];
LibertyAvV1.prototype.commands.ping.get = function() {
    this.sendCommand('ping', 'GET MP all all');
};
LibertyAvV1.prototype.commands.ping.match = /MP\sGET\s(.+)\sALL\s(RX|TX)/i;
LibertyAvV1.prototype.commands.ping.process = function(match) {
    this.processSelectedInput(match);
};

LibertyAvV1.prototype.commands.videoMatrixRoute = {};
LibertyAvV1.prototype.commands.videoMatrixRoute.isAsync = true;
LibertyAvV1.prototype.commands.videoMatrixRoute.get = function() {
    this.broadcastStatus('videoMatrixRoute', this.videoMatrixRoutes);
};
LibertyAvV1.prototype.commands.videoMatrixRoute.set = function(value) {
    if (!this.videoMatrixRoutes.hasOwnProperty(value.videoOutputId)) {
        log.error(this + ' invalid videoOutputId = ' + value.videoOutputId);
        return;
    }

    if (!this.config.videoInputs.hasOwnProperty(value.videoInputId)) {
        log.error(this + ' invalid videoInputId = ' + value.videoInputId);
        return;
    }

    this.videoMatrixRoutes[value.videoOutputId] = value.videoInputId;
    this.broadcastStatus('videoMatrixRoute', this.videoMatrixRoutes);

    this.sendCommand('videoMatrixRoute', 'SET SW ' +
        this.config.videoInputs[value.videoInputId].code + ' all');
};
LibertyAvV1.prototype.commands.videoMatrixRoute.match = /SW\sSET\s(.+)\sALL\s(RX|TX)/i;
LibertyAvV1.prototype.commands.videoMatrixRoute.process = function(match) {
    this.processSelectedInput(match);
};

LibertyAvV1.prototype.initializeSteps = [{
    state: 'gettingVersion',
    action: '$version',
}, {
    state: 'gettingRoutes',
    action: '$getRouteInit',
    getRepeatCount: function() {
        return this.config.hasOwnProperty('videoOutputs') ?
            Object.keys(this.config.videoOutputs).length : 0;
    },
}, {
    state: 'finishingInitialization',
    action: function() {
        this.finishInitialization();
        return true;
    },
}];

LibertyAvV1.prototype.onComputeCaps = function() {
    var caps = this.getCapsTemplate();
    caps.hasVideoSwitcher = true;
    this.computeCapsFromConfig(caps);
    caps.hasBusy = true;
    caps.hasFirmwareVersion = true;

    return caps;
};

LibertyAvV1.prototype.onInitialize = function() {
    this.busy = false;
    this.videoMatrixRoutes = {};
    if (this.config.modelNumber === '-M23lATTrvLd8OYr4mlZ') { 
        this.videoOutputChannel = 'all'; // WyreStorm EX-SW-0301
    }
    this.startInitializer();
};

LibertyAvV1.prototype.processSelectedInput = function(match) { 
    // process the async responses from the device
    if (match[2] === 'TX')  this.txSrc = match[1];
    else this.rxSrc = match[1]; // RX response

    if (this.rxSrc !== 'HDBT_RX')   // using a local receiver source
        this.updateVideoMatrixRoute(this.rxSrc, this.videoOutputChannel);
    else   // using a transmitter source
        this.updateVideoMatrixRoute(this.txSrc, this.videoOutputChannel);
};

LibertyAvV1.prototype.updateVideoMatrixRoute = function(inputCode, outputCode) {
    var inputId = null;
    var outputId = null;

    for (var inId in this.config.videoInputs) {
        if (!this.config.videoInputs.hasOwnProperty(inId)) continue;
        if (this.config.videoInputs[inId].code === inputCode) {
            inputId = inId;
            break;
        }
    }

    if (inputId === null) {
        log.warning(this + ': unmatched video input code: ' + inputCode);
    }

    for (var outId in this.config.videoOutputs) {
        if (!this.config.videoOutputs.hasOwnProperty(outId)) continue;
        if (this.config.videoOutputs[outId].code === outputCode) {
            outputId = outId;
            break;
        }
    }

    if (outputId === null) {
        log.warning(this + ': unmatched video output code: ' + outputCode);
    } else {
        if (this.videoMatrixRoutes[outputId] !== inputId) {
            this.videoMatrixRoutes[outputId] = inputId;
            if (this.fsm.current === 'controlling') {
                this.broadcastStatus('videoMatrixRoute', this.videoMatrixRoutes);
            }
        }
    }
};

module.exports = LibertyAvV1;
